* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  display: block;
  padding: 2px;
  .relay-patch {
    display: flex;
    margin-bottom: calc(var(--spacer) * 2.5);
    #search-relay-input {
      flex: 0;
      margin-right: var(--spacer);
    }
    #custom-relay-input {
      flex: 0;
      margin-right: var(--spacer);
    }
  }
  .vendors-products {
    display: flex;
    #vendor-selector,
    #product-selector {
      flex: 0;
      margin-right: var(--spacer);
    }
    margin-bottom: calc(var(--spacer) * 2.5);
  }
}

#vendor-selector {
  display: inline;
}

#product-selector {
  display: inline;
}

#add-button {
  display: inline;
}

#relay-caching-servers {
  // TODO: FED, pls fix this
  height: 400px;
  min-width: 900px;
}
